import { render, staticRenderFns } from "./ScoreWidget.vue?vue&type=template&id=34424fb5&scoped=true"
import script from "./ScoreWidget.vue?vue&type=script&lang=js"
export * from "./ScoreWidget.vue?vue&type=script&lang=js"
import style0 from "./ScoreWidget.vue?vue&type=style&index=0&id=34424fb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34424fb5",
  null
  
)

export default component.exports